export default "__VITE_ASSET__Bmeu0j$i__"